import styleTheme from './styleTheme'
// import coverImg from '@images/login/coverImg.png'
import coverImg from '@images/login/login_bg.png'
import AppBar from './components/AppBar'
import { transform } from '@utils/intl_lang'
const theme = {
  id: 'horizontal',
  /** 主题 */
  styleTheme,
  /** 公共组件 */
  components: {
    AppBar,
  },
  /** 页面 */
  views: {},
  logo: '',
  coverImg,
  // 'e祺学'
  platformName: transform('zhiniao_portal'),
  title: '学习平台',
}
export default theme
